import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

import { activityAndMovementTestimonialsDataOR4 } from '../_data/activityAndMovementTestimonialsData';

const ActivityAndMovementTestimonials = (): JSX.Element => {
  return (
    <section data-cy="activity-and-movement-testimonials">
      <LandingPageTestimonials
        testimonials={activityAndMovementTestimonialsDataOR4}
        theme="brown"
      />
    </section>
  );
};

export default ActivityAndMovementTestimonials;
